<template>
  <app-data-editor
    :id="id"
    title="Редактирование типа товара"
    resource="goods-types"
    :elements="elements"
    add-message="Тип товара добавлен"
    edit-message="Тип товара изменен"
    @change="(payload) => isChanged = payload"
  />
</template>

<script>
import mixin from "./../../mixins/confirm-cancel-changes.js";
export default {
  mixins: [mixin],
  props: ["id"],
  data() {
    return {
      elements: [
        [
          {
            title: "Наименование",
            name: "title",
            control: {
              type: "title-text",
              required: true,
              rules: [v => !!v || "Наименование обязательно к заполнению"],
            },
            default: "",
          },
        ],
      ],
    };
  },
};
</script>